/* unplugin-vue-components disabled */import script from "./translation-content.vue?vue&type=script&lang=ts&setup=true"
export * from "./translation-content.vue?vue&type=script&lang=ts&setup=true"

import "./translation-content.vue?vue&type=style&index=0&id=c0417aba&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0417aba"]])

export default __exports__